<template>
  <div
    :class="['log',{logMedia:dev}]"
    @click="close"
  >
    <img :src="require('@/assets/img/alert.png')">
  </div>
</template>

<script>
export default {
  name: "Alert",
  props: {
    alertTypeFn: Function
  },
  computed: {
    dev() {
      return this.$store.state.dev;
    }
  },
  methods: {
    close() {
      this.alertTypeFn(false);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/com.scss";
.log {
  @include LTput();
  @include wh(100%, 100%);
  z-index: 999;
  background: rgba(37, 37, 37, 0.7);

  img {
    @include wh(8.93rem);
    @include LTRBcenter;
    transform: translate(-50%, -100%);
  }
}
.logMedia {
  img {
    transform: translate(-50%, -100%) rotate(90deg);
  }
}
</style>


